import { render, staticRenderFns } from "./SaitenInputQuestionPdf.vue?vue&type=template&id=14058f8f&"
import script from "./SaitenInputQuestionPdf.vue?vue&type=script&lang=ts&"
export * from "./SaitenInputQuestionPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports